
import React, { useEffect, useState, useRef, useMemo } from "react";
import DashboardMenu from "./common/dashboard-menu";
import { Link, useLocation } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { getTemplate, getAllBooking, getActiveBooking, getPendingBooking, getProfile, getBooking, getBookingStatus, resetPasswordAuthenticate, resetBooking, getRecommendedVehicle, uploadBookingAgreement } from "../../core/data/redux/action";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch, RootState } from "../../core/data/redux/store";
import { Calendar } from "primereact/calendar";
import Pagination from "../common/pagination";
import Lottie from "lottie-react";
import Loader from "../../core/data/img/car_loading.json";
import { toast, } from "react-toastify";
import { all_routes } from "../router/all_routes";
import ViewBooking from "../../core/data/modals/viewBooking";
import CancelBooking from "../../core/data/modals/cancelBooking";
import BookingPayment from "../booking/booking-payment";
import UploadLicense from "../../core/data/modals/uploadLicense";

import Checkout from "../../core/data/modals/checkout";
import ContactConfirm from "../../core/data/modals/contactConfirm";
import EnquiryForm from "../../core/data/modals/enquiry";

import UploadSelfieWithCar from "../../core/data/modals/uploadSelfieWithCar";
import UploadAddressProof from "../../core/data/modals/uploadAddressProof";


import Terms from "../../core/data/modals/terms";
import SignaturePad from 'signature_pad';
import BookingAttachment from "../../core/data/modals/bookingAttachment";
import dayjs from "dayjs";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";

// import { FaInfo } from 'react-icons/fa';
// import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css'; // REQUIRED for styles 

// import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { useForm, SubmitHandler } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { generateTimeOptions } from "../../core/data/redux/actions/commonActions";
import { addContactUs, resetContactUs } from "../../core/data/redux/action";
import { formatDateWithTime } from "../../core/data/redux/actions/commonActions";
import * as Yup from "yup";
// import 'react-tooltip/dist/react-tooltip.css';
// import { Box,   Stepper, Step, StepLabel,  } from '@mui/material';

const UserBookings = () => {
  const routes = all_routes;
  const [searchInput, setSearchInput] = useState("");
  const [activeStatus, setActiveStatus] = useState<number | null>(null);
  const [timeOptions, setTimeOptions] = useState<string[]>([]);
  const [showCalendar, setShowCalendar] = useState(false);

  // const [showMenu, setShowMenu] = useState<boolean | null>(false);

  const [dates, setDates] = useState<Date[]>([]);
  const [booking, setBooking] = useState("");
  const signRef = useRef<HTMLCanvasElement | null>(null);
  const [first, setFirst] = useState(0);
  const [debouncedSearch, setDebouncedSearch] = useState(searchInput);
  const [toastMessage, setToastMessage] = useState('');
  const [toastClass, setToastClass] = useState('bg-success text-white');
  const dispatch = useDispatch<AppDispatch>();
  const [userPendingBookings, setUserPendingBookings] = useState<any[]>([]);
  const [cartBookings, setCartBookings] = useState<any[]>([]);
  const [carDetail, setCarDetail] = useState<any[]>([]);
  const [availabilityStartDate, setAvailabilityStartDate] = useState<Date | null>(null);
  const [availabilityEndDate, setAvailabilityEndDate] = useState<Date | null>(null);
  const [availabilityFromTime, setAvailabilityFromTime] = useState("08:00 AM");
  const [availabilityUntilTime, setAvailabilityUntilTime] = useState("08:00 AM");
  const termsRef = useRef(null);
  const signaturePad = useRef(null);
  const savedSignature = useRef(null); // To store drawing data
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [isAccepted, setIsAccepted] = useState(false);
  const [userBookings, setUserBookings] = useState<any[]>([]);
  const [userActiveBookings, setUserActiveBookings] = useState<any[]>([]);
  const [bookingDetails, setBookingDetails] = useState<any | null>(null);

  const dataURLToBlob = (dataURL: any) => {
    const arr = dataURL.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  };

  const handleScroll = () => {
    const el = termsRef.current;
    if (!el) return;
    const isBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 300;
    setShowScrollTop(isBottom);
    setIsAccepted(isBottom);
  };

  useEffect(() => {
    dispatch(getTemplate({ "name": "terms_conditions" }))
  }, []);


  const scrollToTop = () => {
    if (termsRef.current) {
      termsRef.current.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  };


  const clearSignature = () => {
    const canvas = signaturePad.current;
    if (canvas) {
      signaturePad?.current.clear();
      savedSignature.current = null;
    }
    // setSignature(null);
  };


  const handleAccept = () => {
    if (signaturePad.current?.isEmpty()) {
      return;
    }
    const dataURL = signaturePad?.current.toDataURL("image/png");
    const blob = dataURLToBlob(dataURL);

    if (blob) {
      const fileName = `${user?.first_name}_signature_${user?.id}_${bookingDetail?.id}.png`;
      const signFile = new File([blob], fileName, { type: "image/png" });

      const formData = new FormData();

      const data = {
        upload_type: getAttachmentStatus("upload", "", "signature") ? "reupload" : "initial",
        booking_id: bookingDetail?.id,
        billing_terms_conditions: isAccepted,
      };

      Object.entries(data).forEach(([key, value]) => {
        formData.append(key, value);
      })

      formData.append(`attachments[0][file]`, signFile);
      formData.append(`attachments[0][label]`, 'signature');
      formData.append(`attachments[0][type]`, "upload");
      dispatch(uploadBookingAgreement(formData))

    }
  };


  const { contactUsSuccess, contactUsError, contactUsLoading, pendingBookings, activeBookings, bookingUploadLicenseSuccess, bookingUploadLicenseError, bookingDetailLoading, bookingDetail, systemSettings, templateList, bookingsSuccess, bookingsError, user, bookingsLoading, bookings, bookingStatusList, vehicleRecommendationLoading, vehicleRecommendationList } = useSelector(
    (state: RootState) => ({
      bookings: state.booking.bookings,
      bookingStatusList: state.booking.bookingStatusList,
      bookingsLoading: state.booking.bookingsLoading,
      user: state.auth.user,
      vehicleRecommendationLoading: state.vehicleRecommendation.vehicleRecommendationLoading,
      vehicleRecommendationList: state.vehicleRecommendation.vehicleRecommendationList,
      bookingsSuccess: state.booking.bookingsSuccess,
      bookingsError: state.booking.bookingsError,
      templateList: state.template.templateList,
      systemSettings: state.auth.systemSettings,
      bookingDetail: state.booking.bookingDetail,
      bookingDetailLoading: state.booking.bookingDetailLoading,
      bookingUploadLicenseSuccess: state.booking.bookingUploadLicenseSuccess,
      bookingUploadLicenseError: state.booking.bookingUploadLicenseError,
      contactUsLoading: state.contactUs.contactUsLoading,
      contactUsSuccess: state.contactUs.contactUsSuccess,
      contactUsError: state.contactUs.contactUsError,
      activeBookings: state.booking.activeBookings,
      pendingBookings: state.booking.pendingBookings,
    })
  );






  useEffect(() => {
    setCartBookings(
      vehicleRecommendationList?.recommendation
        ? [vehicleRecommendationList.recommendation]
        : []
    );
  }, [vehicleRecommendationList]);


  useEffect(() => {
    setUserActiveBookings(activeBookings?.data || []);
  }, [activeBookings]);


  useEffect(() => {
    setUserBookings(bookings?.data || []);
  }, [bookings]);

  useEffect(() => {
    setUserPendingBookings(pendingBookings?.data || []);
  }, [pendingBookings]);


  useEffect(() => {
    if (systemSettings?.booking_start_time && systemSettings?.booking_end_time) {
      const options = generateTimeOptions(systemSettings.booking_start_time, systemSettings.booking_end_time, 0);
      setTimeOptions(options);
    }
  }, [systemSettings]);

  useEffect(() => {
    if (isAccepted && signRef.current) {
      signaturePad.current = new SignaturePad(signRef.current);
    }

    if (isAccepted && savedSignature.current && signaturePad.current) {
      signaturePad.current.fromData(savedSignature.current); // Restore previous signature
    }
  }, [isAccepted]);


  useEffect(() => {
    return () => {
      if (signaturePad.current && !isAccepted) {
        savedSignature.current = signaturePad.current.toData();
      }
    };
  }, [isAccepted]);

  const closeModal = () => {
    const modalElement = document.getElementById('cancel_booking');
    const checkoutModalElement = document.getElementById('checkout');
    const backdrop = document.querySelector(".modal-backdrop");


    if (modalElement && modalElement.style.display !== "hidden") {
      modalElement.classList.remove("show");
      modalElement.style.display = "none";
      modalElement.classList.remove("show", "modal-open");
    }

    if (checkoutModalElement && checkoutModalElement.style.display !== "hidden") {
      checkoutModalElement.classList.remove("show");
      checkoutModalElement.style.display = "none";
      checkoutModalElement.classList.remove("show", "modal-open");
    }

    if (backdrop) {
      backdrop.remove();
    }

    document.body.classList.remove("modal-open");
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";
  };

  const closeContactModal = () => {
    const modalElement = document.getElementById("enquiry");
    const backdrop = document.querySelector(".modal-backdrop");

    if (modalElement) {
      modalElement.style.display = "none";
      modalElement.classList.remove("show", "modal-open");
    }

    if (backdrop) {
      backdrop.remove();
    }

    document.body.classList.remove("modal-open");
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";
  };

  const viewBooking = (id: any) => {
    dispatch(getBooking(id));
  }


  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchInput);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchInput]);

  useEffect(() => {
    if (localStorage.getItem("token")) {
      dispatch(getProfile());
    }

    dispatch(getRecommendedVehicle());


    dispatch(getBookingStatus());
  }, [dispatch]);


  const handlePaymentClick = (event: React.MouseEvent, bookings: any) => {
    event.preventDefault();
    setBookingDetails(bookings);
    // setShowMenu(false);

  };

  useEffect(() => {
    if (bookingsSuccess) {
      showToast(bookingsSuccess);
      closeModal();
      dispatch(resetBooking());

    } else if (bookingsError || bookingUploadLicenseError) {
      showToast(bookingsError || bookingUploadLicenseError)


    }

  }, [bookingsSuccess, bookingsError]);

  const showToast = (message: any) => {
    setToastClass((bookingsError || bookingUploadLicenseError) ? 'bg-danger text-white' : 'bg-success text-white');
    setToastMessage(message);
  };


  useEffect(() => {
    if (bookingUploadLicenseSuccess) {
      showToast(bookingUploadLicenseSuccess);
    } else if (bookingUploadLicenseError) {
      showToast(bookingUploadLicenseError);
    }
  }, [bookingUploadLicenseSuccess, bookingUploadLicenseError]);



  type ContactFormValues = {
    name: string;
    email: string;
    message: string;
    phone: string;
  };


  const ContactSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    message: Yup.string(),
    phone: Yup.string().when("$phone", {
      is: (value: any) => value?.trim().length > 0, // Check if phone is not empty
      then: (schema) => schema.length(10, "Phone must be exactly 10 digits"),
      otherwise: (schema) => schema.notRequired(), // Don't validate if empty
    }),
  });


  const {
    register: contactRegister,
    handleSubmit: contactHandleSubmit,
    formState: { errors: contactErrors },
    reset: contactReset,
    // watch,
    // setValue,
    // trigger,
  } = useForm<ContactFormValues>({
    resolver: yupResolver(ContactSchema),
    defaultValues: {
      name: user?.name,
      email: user?.email,
      message: "",
      phone: user?.mobile,
    },
  });


  const contactOnSubmit: SubmitHandler<ContactFormValues> = (data) => {
    const currentUrl = `${window.location.origin}${routes.listingDetails}/${carDetail?.vin}${location.search}`;
    dispatch(addContactUs({
      ...data,
      query_type: "enquiry",
      vehicle_id: carDetail?.id,
      ...(carDetail?.vehicle_current_status === "Booked" && {
        start_date: formatDateWithTime(availabilityStartDate, availabilityFromTime),
        end_date: formatDateWithTime(availabilityEndDate, availabilityUntilTime),
        query_type: "check_availability",
      }),
      fairental_message: `Hi Fairental team, we have a car enquiry from a customer ${data?.name}, ${data.phone}, ${data.email}, Enquiry :${data.message}, please click on the link to see the car details: ${currentUrl}`

    }));

    const encodedMessage = encodeURIComponent(
      `Hi Fairental team, we have a car enquiry from a customer ${data?.name}, ${data.phone}, ${data.email}, Enquiry :${data.message}, please click on the link to see the car details: ${currentUrl}`
    );

    const value = {
      encodedMessage: encodedMessage,
      timestamp: new Date().getTime(),
      currentUrl: currentUrl,
    };

    sessionStorage.setItem("contactForm", JSON.stringify(value));


  };

  useEffect(() => {

    if (user) {
      contactReset({
        name: user.name ?? "",
        email: user.email ?? "",
        phone: user.mobile ?? "",
        message: "",
      });
    }
  }, [user, contactReset, contactUsSuccess]);



  useEffect(() => {
    if (contactUsSuccess) {
      showToast(contactUsSuccess);

      closeContactModal();
      dispatch(resetContactUs());


    } else if (contactUsError) {
      showToast(contactUsError);
      dispatch(resetContactUs());
    }

  }, [contactUsSuccess, contactUsError]);


  useEffect(() => {
    setFirst(1);

    const fromDate = dates?.[0] ? dates[0].toISOString().split("T")[0] : null;
    const toDate = dates?.[1] ? dates[1].toISOString().split("T")[0] : null;

    dispatch(getAllBooking({
      show_history: 1,
      itemsPerPage: 10,
      page: 1,
      status: activeStatus,
      from_date: fromDate,
      to_date: toDate,
      search: debouncedSearch,
    })
    );

  }, [dates, activeStatus, debouncedSearch]);


  useEffect(() => {
    dispatch(getActiveBooking({
      show_active: 1,
      itemsPerPage: 10,
      page: 1,

    })
    );
  }, []);

  useEffect(() => {
    dispatch(getPendingBooking({
      show_pending: 1,
      itemsPerPage: 10,
      page: 1,

    })
    );
  }, []);


  const pickupLocation = (res: any) => {
    return (
      <p className="text-wrap" data-bs-toggle="modal"
        onClick={() => { viewBooking(res?.id); }}
        data-bs-target="#view_booking">
        {res?.pickup_location}
      </p>
    );
  };


  const BookingId = (res: any) => {
    return (
      <>
        <p data-bs-toggle="modal"
          onClick={() => { viewBooking(res?.id); }}
          data-bs-target="#view_booking" className="bookbyid">
          #{res?.booking_id}
        </p>

        <p className="text-wrap" data-bs-toggle="modal"
          onClick={() => { viewBooking(res?.id); }}
          data-bs-target="#view_booking" >{res?.vehicle_name}</p>
      </>

    );
  };


  const BookedOn = (res: any) => {
    if (!res?.booked_on) return <p>--</p>;

    const date = new Date(res?.booked_on);
    const formattedDate = date.toLocaleDateString('en-US', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });

    return (
      < >
        {formattedDate}
      </ >
    );
  };


  const SetDate = (date: string, time: string) => {
    if (!date && !time) return <p>--</p>;

    const set_date = new Date(date);
    const formattedDate = set_date?.toLocaleDateString('en-US', {
      day: '2-digit',
      month: 'short',
      year: '2-digit',
    });

    const set_time = new Date(`1970-01-01T${time}`);
    const formattedTime = set_time?.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });

    return (
      <>
        {formattedDate}, {formattedTime}
      </>
    );
  };



  const TripStartDate = (res: any) => {

    return (
      <p data-bs-toggle="modal"
        onClick={() => { viewBooking(res?.id); }}
        data-bs-target="#view_booking">
        {SetDate(res?.booking_start_date, res?.booking_start_time)}
      </p>
    );
  };

  const TripEndDate = (res: any) => {

    return (
      <p data-bs-toggle="modal"
        onClick={() => { viewBooking(res?.id); }}
        data-bs-target="#view_booking">
        {SetDate(res?.booking_return_date, res?.booking_return_time)}

      </p>
    );
  };



  const CartStartTripDate = (res: any) => {

    return (
      <p className="text-wrap" data-bs-toggle="modal"
        onClick={() => { viewBooking(res?.id); }}
        data-bs-target="#view_booking">
        {SetDate(res?.start_date, res?.start_time)}
      </p>
    );
  };

  const CartEndTripDate = (res: any) => {

    return (
      <p className="text-wrap" data-bs-toggle="modal"
        onClick={() => { viewBooking(res?.id); }}
        data-bs-target="#view_booking">
        {SetDate(res?.return_date, res?.return_time)}
      </p>
    );
  };

  const PaymentUpfront = (res: any) => {
    return (

      <p data-bs-toggle="modal"
        onClick={() => {
          viewBooking(res?.id);
        }}
        data-bs-target="#view_booking" className="bookbyid">
        Payment Upfront: ${res?.cost_summary?.initialPayment}

      </p>
    );
  };





  const FuturePayment = (res: any) => {
    return (

      res?.cost_summary?.nextBillingCycle?.payment_amount ?
        <p data-bs-toggle="modal"
          onClick={() => {
            viewBooking(res?.id);
          }}
          data-bs-target="#view_booking" className="bookbyid">Future Payment: ${res?.cost_summary?.nextBillingCycle?.payment_amount}/{res?.cost_summary?.paymentMethod?.name} </p>
        : "N/A"
    );
  };

  const Expires = (res: any) => {
    const date = new Date(res?.token_expires_at);
    const formattedDate = date.toLocaleDateString('en-US', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true, // Use false for 24-hour format

    });

    return (
      <p>
        {formattedDate}
      </p>
    );
  };


  const Status = (data: any) => {


    const res = data;



    return (
      <span data-bs-toggle="modal" onClick={() => { viewBooking(res?.id); }} data-bs-target="#view_booking"
        className={`${res?.status_name == "pending"
          ? "badge badge-light-warning"
          : res?.status_name == "confirmed"
            ? "badge badge-light-success"
            : res?.status_name == "completed"
              ? "badge badge-light-success"
              : res?.status_name == "canceled"
                ? "badge badge-light-danger"
                : res?.status_name == "in_progress"
                  ? "badge badge-light-secondary"
                  : res?.status_name == "extended"
                    ? "badge badge-light-warning"
                    : "badge badge-light-info"
          } text-wrap text-start`}
      >

        {res?.status_display_name}

      </span>
    );
  };


  // const pendingStatus = (res: any) => {
  //   return (
  //     <span

  //       className={` ${res?.status == "open"
  //         ? "badge badge-light-success"
  //         : res?.status == "booked"
  //           ? "badge badge-light-info"
  //           : res?.status == "expired"
  //             ? "badge badge-light-danger"
  //             : res?.status == "closed_by_admin"
  //               ? "badge badge-light-warning"
  //               : "badge badge-light-secondary"
  //         }`}
  //     >

  //       {res?.status
  //         ?.toLowerCase()
  //         .replace(/_/g, " ") // Replace underscores with spaces
  //         .replace(/^\w/, (c: string) => c.toUpperCase())}

  //     </span>
  //   );
  // };


  const vehicleDetails = (res: any) => {
    return (
      <>
        <p className="text-wrap" data-bs-toggle="modal"
          onClick={() => { viewBooking(res?.id); }}
          data-bs-target="#view_booking">   {res?.vehicle?.year_make_model} </p>

        {/* <p > <span className="fw-bold">  VIN:  </span>  {res?.vehicle?.vin} </p>

            <p > <span className="fw-bold">  Plate Number:  </span>  {res?.vehicle?.plate_number} </p> */}

      </>

    );
  };



  const ActiveAction = (data: any) => {
    const res = data.res;


    return (
      <div className="dropdown dropdown-action ">
        <a
          href="#"
          className={`dropdown-toggle`}
          data-bs-toggle="dropdown"
          data-bs-targe="#active_action"
          aria-expanded="false"
        // onClick={() => {
        //   setShowMenu(!showMenu);
        // }}
        >
          <i className="fas fa-ellipsis-vertical pe-1" /> More
        </a>
        <div className={`dropdown-menu dropdown-menu-end`} id="active_action">


          {
            (
              <a
                className="dropdown-item"
                href="#"
                data-bs-toggle="modal"
                data-bs-target="#view_attachment"

                onClick={() => {
                  setBooking(res);
                  // setShowMenu(false);

                  // dispatch(resetPasswordAuthenticate());
                }}

              >
                <i className="fa fa-paperclip" />  Preliminary contract
              </a>
            )}



        </div>
      </div>
    );
  };

  const PendingAction = (data: any) => {

    const res = data.data;


    return (
      <div className="dropdown dropdown-action ">
        <a
          href="#"
          className={`dropdown-toggle`}
          data-bs-toggle="dropdown"
          data-bs-targe="#pending_action"
          aria-expanded="false"
        // onClick={() => {
        //   setShowMenu(!showMenu);
        // }}
        >
          <i className="fas fa-ellipsis-vertical pe-1" /> More
        </a>
        <div className={`dropdown-menu dropdown-menu-end`} id="pending_action">

          {/* <a
            className="dropdown-item"
            href="#"
            onClick={() => {
              viewBooking(res?.id);
              // setShowMenu(false);
            }}
            data-bs-toggle="modal"
            data-bs-target="#view_booking"

          >
            <i className="fas fa-calendar-alt" /> View Booking
          </a> */}

          {(res?.license_status === "pending" || res?.license_status === "rejected") && (
            <a
              className="dropdown-item"
              href="#"
              data-bs-toggle="modal"
              data-bs-target="#upload_license"

              onClick={() => {
                setBooking(res);
                // setShowMenu(false);

              }}

            >
              <i className="fas fa-id-card" /> Upload License
            </a>
          )}


          {(res?.address_proof_status === "pending" || res?.address_proof_status === "rejected") && (
            <a
              className="dropdown-item"
              href="#"
              data-bs-toggle="modal"
              data-bs-target="#upload_address_proof"

              onClick={() => {
                setBooking(res);
                // setShowMenu(false);

              }}

            >
              <i className="fa fa-address-book" /> Upload Address Proof
            </a>
          )}




          {(res?.agreement_status === "pending") && (
            <a
              className="dropdown-item"
              href="#"
              data-bs-toggle="modal"
              data-bs-target="#terms"

              onClick={() => {
                viewBooking(res?.id);
                clearSignature();
                // setShowMenu(false);

              }}

            >
              <i className="fas fa-file-signature" /> Sign Agreement
            </a>
          )}

          {res?.bookingattachments?.filter((item: any) => item.label === "agreement")?.length > 0 &&
            (
              <a
                className="dropdown-item "
                href="#"
                data-bs-toggle="modal"
                data-bs-target="#view_attachment"

                onClick={() => {
                  setBooking(res);
                  // setShowMenu(false);

                  dispatch(resetPasswordAuthenticate());
                }}

              >
                <i className="fa fa-paperclip" />  Preliminary contract
              </a>
            )}






          {res?.payment_status === "pending" && (

            <a
              className="dropdown-item"
              href="#"
              data-bs-toggle="modal"
              data-bs-target="#make_payment"
              onClick={(event) => handlePaymentClick(event, res)}
            >
              <i className="feather icon-credit-card" /> Make Payment
            </a>
          )}


          {/* {
            (
              <a
                className="dropdown-item"
                href="#"
                data-bs-toggle="modal"
                data-bs-target="#view_insurance"

                onClick={() => {
                  setBooking(res);

                }}

              >
                <i className="fa fa-shield-alt" />View Insurance
              </a>
            )} */}



          {/* {
            (
              <a
                className="dropdown-item"
                href="#"
                data-bs-toggle="modal"

                data-bs-target="#selfie_with_car"


                onClick={() => {
                  setBooking(res);

                }}

              >
                <i className="fa fa-camera" />Selfie with car
              </a>
            )} */}

          {res?.status_name === "pending" && <a className="dropdown-item" href="#" data-bs-toggle="modal" data-bs-target="#cancel_booking"

            onClick={() => {
              setBooking(res);
              // setShowMenu(false);

            }}
          >
            <i className="fas fa-calendar-times" /> Cancel Booking
          </a>}

        </div>
      </div>
    );
  };




  const CartAction = () => {
    return (
      <a className="dropdown-item px-0 align-items-baseline" href={vehicleRecommendationList?.bookingUrl} >
        <i className="feather icon-eye pe-1" /> View
      </a>

    );
  };


  const closeConfirmModal = () => {
    const backdrop = document.querySelector(".modal-backdrop");
    const confirmModal = document.getElementById("confirm");

    if (confirmModal) {
      confirmModal.style.display = "none";
      confirmModal.classList.remove("show", "modal-open");
    }
    if (backdrop) {
      backdrop.remove();
    }
  }

  const onPage = (event: any) => {
    setFirst(event);
    window.scrollTo(0, 0);

    dispatch(getAllBooking({
      show_history: 1,
      itemsPerPage: event.rows, page: event, status: activeStatus, from_date: dates[0]?.toISOString(), to_date: dates[1]?.toISOString(), search: searchInput
    }));

  }


  const signatureDataURL = signaturePad.current?.toDataURL("image/png");


  // const getAttachmentStatus = (captured_type: any, label: any): string => {
  //   const matchingAttachments = bookingDetail?.bookingattachments?.filter((att: any) => att?.captured_type === captured_type && att?.label === label && att?.file_url) || [];

  //   if (matchingAttachments.length === 0) {
  //     return '<span>Not Uploaded</span>';
  //   }

  //   return matchingAttachments.map((att: any, index: any) => {

  //     return `<img key="${index}" src="${att.file_url}" alt="${label} preview ${index + 1}" style="width: 300px;  object-fit: cover; margin: 10px;" />`;
  //   }).join('');
  // };


  const getAttachmentStatus = (captured_type_1: any, captured_type_2: any, label: any): string => {
    const attachments = bookingDetail?.bookingattachments || [];

    const matchingAttachments = attachments.filter((att: any) =>
      [captured_type_1, captured_type_2].includes(att?.captured_type) &&
      att?.label === label &&
      att?.file_url
    );

    if (matchingAttachments.length === 0) {
      return '<span>Not Uploaded</span>';
    }

    return matchingAttachments.map((att: any, index: any) =>
      `<img key="${index}" src="${att.file_url}" alt="${label} preview ${index + 1}" style="width: 300px; object-fit: cover; margin: 10px;" />`
    ).join('');
  };



  const bookingData = useMemo(() => ({
    logo: '<img class="img-fluid" src="/assets/img/logo/fairRentallogo-small.png" alt="Logo" style="width: 35%;">',
    startDate: dayjs(bookingDetail?.booking_start_date).format('MM-DD-YYYY') + " " + dayjs(bookingDetail?.booking_start_time, 'HH:mm:ss').format('HH:mm'),
    endDate: dayjs(bookingDetail?.booking_return_date).format('MM-DD-YYYY') + " " + dayjs(bookingDetail?.booking_return_time, 'HH:mm:ss').format('HH:mm'),

    bookingPrice: `${bookingDetail?.cost_summary?.initialRentalCost}${bookingDetail?.cost_summary?.paymentMethod?.name === "Daily"
      ? "/Day"
      : bookingDetail?.cost_summary?.paymentMethod?.name === "Weekly"
        ? "/Week"
        : "/Full"
      }`,

    rentalPlan: bookingDetail?.cost_summary?.paymentMethod?.name,
    securityDeposit: `${bookingDetail?.cost_summary?.feeTypes?.find((item: any) => item.fee_type === "Security Deposit")?.calcAmount}
    ${bookingDetail?.cost_summary?.feeTypes?.find((item: any) => item.fee_type === "Security Deposit")?.reason
        ? " (" + bookingDetail?.cost_summary?.feeTypes?.find((item: any) => item.fee_type === "Security Deposit")?.reason + ")"
        : ""
      }`
    ,

    includedDistance: "Unlimited miles",
    pickupLocation: systemSettings?.default_pickup_location,
    protectionPlan: "Default",
    plateNumber: bookingDetail?.vehicle?.plate_number,
    make: bookingDetail?.vehicle?.make,
    model: bookingDetail?.vehicle?.model,
    vin: bookingDetail?.vehicle?.vin,
    year: bookingDetail?.vehicle?.year,
    color: bookingDetail?.vehicle?.color,
    mileage: bookingDetail?.checkin?.odometer,
    fuelType: bookingDetail?.vehicle?.fuel_type,
    driverName: bookingDetail?.user?.last_name ?
      bookingDetail?.user?.first_name + " " + bookingDetail?.user?.last_name : bookingDetail?.user?.first_name,

    signature: signaturePad.current?.isEmpty() ?
      `<img src="${bookingDetail?.bookingattachments?.filter((att: any) =>
        ["signature"].some(keyword =>
          att?.name?.toLowerCase().includes(keyword.toLowerCase())
        )
      )?.[0]?.file_url || []}" style="width: 50px;" />` : `<img src="${signatureDataURL}" style="width: 50px;" />`,
    selfie: getAttachmentStatus("selfie", "", "driving_license"),
    license: getAttachmentStatus("upload", "", "driving_license"),
    approveDate: dayjs().format('MM-DD-YYYY'),
    payment_model: bookingDetail?.payment_model,
    // checkin: getAttachmentStatus("capture", "upload", "checkin_car_image"),
    internalpictures: getAttachmentStatus("capture", "upload", "checkin_internal_picture"),
    externalpictures: getAttachmentStatus("capture", "upload", "checkin_external_picture"),
    odometerpictures: getAttachmentStatus("capture", "upload", "checkin_odometer_picture"),
    underhoodpictures: getAttachmentStatus("capture", "upload", "checkin_underhood_picture"),
    registrationstrickerpictures: getAttachmentStatus("capture", "upload", "checkin_registration_sticker_picture"),
    oilchangestrickerpictures: getAttachmentStatus("capture", "upload", "checkin_oilchange_sticker_picture"),
    tollstrickerpictures: getAttachmentStatus("capture", "upload", "checkin_toll_sticker_picture"),
    sparetyrepictures: getAttachmentStatus("capture", "upload", "checkin_spare_tyre_picture"),

  }), [signRef, signatureDataURL, bookingDetail, systemSettings, user]);




  const BookingAgreement: React.FC = () => {

    const replacePlaceholders = (template: string, data: Record<string, any>) => {
      return template?.replace(/\{(\w+)\}/g, (_, key) => {
        return data[key] || "N/A";
      });
    };

    const filledContent = replacePlaceholders(templateList?.content, bookingData);

    return <div dangerouslySetInnerHTML={{ __html: filledContent }} />;

  };


  const handleCloseToast = () => {
    setToastMessage('');

  };



  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const getParam = (key: string) => {
    const value = queryParams.get(key);
    return value ? decodeURIComponent(value) : "";
  };



  useEffect(() => {

    const bookingList = [
      ...(Array.isArray(userActiveBookings) ? userActiveBookings ?? [] : []),
      ...(Array.isArray(userBookings) ? userBookings ?? [] : []),
      ...(Array.isArray(userPendingBookings) ? userPendingBookings ?? [] : []),
    ];

    if (bookingList) {

      const data = bookingList?.find((item: any) => item?.id?.toString() === getParam("bookingId"));



      if (data) {
        setBooking(data);
        // dispatch(resetPasswordAuthenticate());

        if (getParam("licensePending") === "0" && (data?.license_status === "pending" || data?.license_status === "rejected")) {
          const LicenseModal = document.getElementById("upload_license");

          if (LicenseModal && LicenseModal.style.display !== "block") {

            LicenseModal.style.display = "block";
            LicenseModal.classList.add("show", "modal-open");

            const backdrop = document.createElement("div");
            backdrop.className = "modal-backdrop fade show";
            document.body.appendChild(backdrop);
            document.body.classList.add("modal-open");
            document.body.style.overflow = "hidden";
            document.body.style.paddingRight = "0px";
          }
        } else if (getParam("paymentPending") === "0" && (data?.payment_status === "pending" || data?.payment_status === "rejected")) {
          const PaymentPendingModal = document.getElementById("make_payment");

          if (PaymentPendingModal && PaymentPendingModal.style.display !== "block") {

            setBookingDetails(data);

            PaymentPendingModal.style.display = "block";
            PaymentPendingModal.classList.add("show", "modal-open");

            const backdrop = document.createElement("div");
            backdrop.className = "modal-backdrop fade show";
            document.body.appendChild(backdrop);
            document.body.classList.add("modal-open");
            document.body.style.overflow = "hidden";
            document.body.style.paddingRight = "0px";
          }
        }

      }
    }


  }, [userActiveBookings, userBookings]);


  useEffect(() => {
    if (toastMessage) {
      if (toastClass === 'bg-danger text-white') {
        toast.error(toastMessage, { position: "top-right", hideProgressBar: true, onClose: handleCloseToast, progress: undefined, toastId: "", })
      } else {
        toast.success(toastMessage, { position: "top-right", hideProgressBar: true, onClose: handleCloseToast, progress: undefined, toastId: "", })
      }

    }
  }, [toastMessage, toastClass]);


  // const steps = [
  //   { label: 'Licence', subLabel: ' ', icon: 'fa fa-id-card', status: 'license_status' },
  //   { label: 'Address Proof', subLabel: ' ', icon: 'fa fa-address-book', status: 'address_proof_status' },
  //   { label: 'Payment', subLabel: '(Waiting for payment confirmation)', icon: 'fa fa-credit-card', status: 'payment_status' },
  //   { label: 'Selfie With Car', subLabel: ' ', icon: 'fa fa-camera', status: 'selfie_with_car_status' },
  //   { label: 'Insurance', subLabel: '(Insurance being processed)', icon: 'fa fa-shield-alt', status: 'insurance_status' },
  //   { label: 'Preliminary Rental Agreement', subLabel: ' ', icon: 'fa fa-file-signature', status: 'agreement_status' },
  // ];


  // interface CustomStepIconProps {
  //   active: boolean;
  //   completed: boolean;
  //   upcoming?: boolean; // optional if you want
  //   icon: string; // icon className or you could use React.ReactNode if you pass JSX icon
  // }

  // const CustomStepIcon: React.FC<CustomStepIconProps> = ({ completed, active }) => {

  //   // Color logic
  //   const blue = '#009FDF';
  //   // const gray = '#BDBDBD';

  //   return (
  //     <Box
  //       sx={{
  //         width: 24,
  //         height: 24,
  //         borderRadius: '50%',
  //         border: (completed || active) ? `1px solid ${blue}` : '1px solid #A0A0A0',
  //         backgroundColor: completed ? blue : active ? "" : '#A0A0A0',
  //         display: 'flex',
  //         alignItems: 'center',
  //         justifyContent: 'center',
  //         color: completed ? 'white' : blue,
  //         fontSize: 18,
  //       }}
  //     >
  //       {completed ? '✓' : ' '}
  //     </Box>
  //   );
  // };

  // const CustomConnector = styled(StepConnector, {
  //   shouldForwardProp: (prop) => prop !== 'status',
  // })(({ completed, active }: { completed: string, active: string, }) => ({
  //   [`& .${stepConnectorClasses.line}`]: {
  //     borderLeftWidth: 2,
  //     borderLeftStyle: 'solid',
  //     minHeight: 24,
  //     borderLeftColor: (completed || active) ? '#5cb85c' : '#ccc',
  //   },
  // }));

  // function StatusStep(bookings: any) {
  //   const [activeStep,] = useState(1);

  //   return (
  //     <Box
  //       sx={{

  //         borderRadius: 2,
  //         p: 0,
  //         width: "100%",

  //         //         '& .MuiStepConnector-root:first-of-type': {
  //         //   display: 'none',
  //         // },

  //       }}
  //     >
  //       <Stepper
  //         activeStep={activeStep}
  //         orientation="vertical"

  //         sx={{
  //           '& .MuiStep-root': {
  //             flexDirection: 'row-reverse',
  //             alignItems: 'flex-start',
  //           },
  //           '& .MuiStepLabel-label': {
  //             mr: 2,
  //             textAlign: 'right',
  //           },

  //           '& .MuiStepLabel-root': {
  //             padding: "3px 0px",
  //           },

  //           '& .MuiStepConnector-root': {
  //             marginLeft: 'auto',
  //             marginRight: '1.2rem',
  //           },


  //           '& .MuiStepConnector-line': {
  //             // "&:first-child": {
  //             //   minHeight: 0
  //             // },
  //             border: "none",
  //             minHeight: 20,
  //           },


  //         }}

  //       >
  //         {steps?.map((step, index) => {
  //           const status = bookings?.[step?.status];
  //           const isApproved = status === "approved";

  //           // Determine which step should be active
  //           let canDo = false;
  //           if (["license_status", "address_proof_status", "payment_status"].includes(step.status)) {
  //             // Can be done anytime
  //             canDo = true;
  //           } else if (step.status === "selfie_with_car_status") {
  //             // Enabled only if license, address proof, and payment are approved
  //             canDo = ["license_status", "address_proof_status", "payment_status"].every(
  //               (s) => bookings?.[s] === "approved"
  //             );
  //           } else if (step.status === "insurance_status") {
  //             // Insurance shown only after selfie is approved
  //             canDo = bookings?.["selfie_with_car_status"] === "approved";
  //           } else if (step.status === "agreement_status") {
  //             // Agreement enabled only after insurance is done
  //             canDo = bookings?.["insurance_status"] === "approved";
  //           }

  //           // Determine visual states
  //           const completed = isApproved;
  //           const active = !isApproved && canDo;
  //           const upcoming = !isApproved && !canDo;

  //           const connectorColor = completed ? '#009FDF' : '#A0A0A0';

  //           return (
  //             <Box
  //               className="w-100 p-0"
  //               key={step.label}
  //               sx={{ position: 'relative', pl: 2, width: "100%" }}
  //             >
  //               {index < steps.length - 1 && (
  //                 <Box
  //                   sx={{
  //                     position: 'absolute',
  //                     top: 50,
  //                     right: 20,
  //                     height: 'calc(100% - 30px)',
  //                     borderLeft: `2px solid ${connectorColor}`,
  //                     zIndex: 0,
  //                   }}
  //                 />
  //               )}

  //               <Step completed={completed}>
  //                 <StepLabel
  //                   StepIconComponent={() => (
  //                     <CustomStepIcon
  //                       active={active}
  //                       completed={completed}
  //                       upcoming={upcoming}
  //                       icon={step.icon}
  //                     />
  //                   )}
  //                   sx={{ flexDirection: 'row-reverse' }}
  //                 >
  //                   <Box className="d-flex align-items-center text-start gap-2">
  //                     <i
  //                       className={step.icon}
  //                       style={{
  //                         fontSize: 20,
  //                         minWidth: 24,
  //                         color: active || completed ? '#009FDF' : '#A0A0A0',
  //                       }}
  //                     />
  //                     <div>
  //                       <Box
  //                         sx={{
  //                           color: active || completed ? '#000' : '#A0A0A0',
  //                         }}
  //                       >
  //                         <p className={active || completed ? "mb-0 fw-bold" : "mb-0"}>
  //                           {step.label}
  //                           <FaInfo
  //                             className="ms-1"
  //                             data-tooltip-id="info-tooltip"
  //                             data-tooltip-content="This is additional info"
  //                             style={{
  //                               color: '#007bff',
  //                               fontSize: '12px',
  //                               cursor: 'pointer',
  //                               outline: 'none',
  //                             }}
  //                             tabIndex={0}
  //                             onFocus={(e) => e.currentTarget.style.outline = 'none'}
  //                           />
  //                           {/* Only show upload icon if active and not completed */}
  //                           {active && !completed && (
  //                             <i
  //                               className="fa fa-upload ms-1"
  //                               style={{ color: '#007bff', fontSize: '12px' }}
  //                               data-bs-toggle="modal"
  //                               data-bs-target={
  //                                 step?.status === "license_status" ? "#upload_license"
  //                                   : step?.status === "address_proof_status" ? "#upload_address_proof"
  //                                     : step?.status === "payment_status" ? "#make_payment"
  //                                       : step?.status === "selfie_with_car_status" ? "#selfie_with_car"
  //                                         : step?.status === "insurance_status" ? "#view_insurance"
  //                                           : step?.status === "agreement_status" ? "#terms"
  //                                             : ""
  //                               }
  //                             />
  //                           )}
  //                           <Tooltip id="info-tooltip" place="top" />
  //                         </p>
  //                         {step.subLabel && step.status !== "completed" && (
  //                           <p className="mb-0 fs-12">{step.subLabel}</p>
  //                         )}
  //                       </Box>
  //                     </div>
  //                   </Box>
  //                 </StepLabel>
  //               </Step>
  //             </Box>
  //           );
  //         })}


  //       </Stepper>
  //     </Box >
  //   );
  // }

  return (
    <>

      <DashboardMenu />




      <div className="content">
        <div className="container">



          {/* <div className="row d-none d-md-block">
            <div className="col-lg-12">
              <div className="sorting-info">
                <div className="row d-flex align-items-center">
                  <div className="col-xl-12 col-lg-8 col-sm-12 col-12 ">
                    <div className="booking-lists">

                      <ul className="nav">
                        <li onClick={() => {
                          setActiveStatus(null);
                        }} >
                          <Link className={activeStatus === null ? "active" : ""} to={routes.userBookings}>All Bookings</Link>
                        </li>

                      </ul>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div> */}

          <div className="row">


            {vehicleRecommendationLoading || bookingsLoading ?
              <div className="d-flex justify-content-center align-items-center">
                <Lottie animationData={Loader} loop={true} style={{ width: 300, height: 300 }} />
              </div>
              : <>

                {/* All Bookings */}




                {activeStatus === null && activeBookings?.data?.length > 0 && activeBookings?.meta?.total_items > 0 && <>
                  <div className="col-lg-12 d-flex">
                    <div className="card book-card flex-fill mb-0">
                      <div className="card-header border-bottom-0 mt-0 pt-0 px-0">
                        <div className="row align-items-center">
                          <div className="col-8  col-md-5">
                            <h4 className="align-items-center mb-0"> {"Active Booking"}
                              {/* <span>{pendingBookings?.meta?.total_items}</span> */}
                            </h4>
                          </div>
                        </div>
                      </div>
                      <div className="card-body px-0">
                        <div className="table-responsive dashboard-booking-table dashboard-table dashboard-table-info">
                          <table className="table border">
                            <tbody>
                              {userActiveBookings && userActiveBookings?.map((item: any, index: number) => {

                                return (
                                  <tr key={index}>
                                    <td onClick={() => {
                                      viewBooking(item?.id);
                                    }}
                                      data-bs-toggle="modal"
                                      data-bs-target="#view_booking">
                                      <div className="table-avatar">
                                        <Link
                                          to={routes.userBookings}
                                          className="avatar avatar-lg flex-shrink-0"
                                        >
                                          <ImageWithBasePath
                                            className="avatar-img"
                                            src={item?.vehicle?.primary_image}
                                            alt="Booking"
                                          />
                                        </Link>
                                        <div className="table-head-name flex-grow-1">


                                          <div className="table-avatar">
                                            <div className="table-head-name flex-grow-1 mb-1">
                                              <p className="mb-0">    {item?.vehicle?.year_make_model} </p>
                                            </div>
                                          </div>

                                          <p className="mb-0">Booking ID : #{item.booking_id}</p>

                                          <p className="mb-0 text-wrap" > {SetDate(item?.booking_start_date, item?.booking_start_time)} - {SetDate(item?.booking_return_date, item?.booking_return_time)}
                                          </p>

                                        </div>
                                      </div>
                                    </td>

                                    <td onClick={() => {
                                      viewBooking(item?.id);
                                    }}>
                                      <Status {...item} />
                                    </td>

                                    <td className="align-items-end">
                                      {item?.bookingattachments?.filter((item: any) => item.label === "agreement")?.length > 0 &&
                                        <ActiveAction res={item} />}
                                    </td>

                                    <td className="w-100 text-wrap border-bottom-0">
                                      {/* <p className="mb-0"> Following items to be completed. In order to start reservation</p> */}

                                      {item?.status_name !== "pending" && item?.status_name !== "in-progress" && <Link to="#"
                                        data-bs-toggle="modal"
                                        data-bs-target="#checkout"
                                        className="btn btn-primary text-white w-100 py-1 "
                                        onClick={() => setBooking(item)}

                                      >  End Rental
                                      </Link>}

                                      <Link to="#"
                                        data-bs-toggle="modal"
                                        data-bs-target="#enquiry"

                                        className="btn btn-secondary w-100  text-white py-1 my-1"
                                        onClick={() => setCarDetail(item?.vehicle)}

                                      >    {"Get in touch"}

                                      </Link>
                                    </td>

                                    {/* <td className=" w-100">
                                      <StatusStep bookings={item} />

                                    </td> */}
                                  </tr>
                                );
                              })}


                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>


                </>}



                {/* {activeStatus === null && pendingBookings?.data?.length > 0 && pendingBookings?.meta?.total_items > 0 && <>


                  <div className="col-lg-12 d-flex">
                    <div className="card book-card flex-fill mb-0">
                      <div className="card-header mt-0 pt-0 px-0">
                        <div className="row align-items-center">
                          <div className="col-8  col-md-5">
                            <h4 className="align-items-center mb-0">
                              {"Pending Booking"} 
                            </h4>
                          </div>
                        </div>
                      </div>
                      <div className="card-body px-0">
                        <div className="table-responsive dashboard-booking-table dashboard-table dashboard-table-info">
                          <table className="table">
                            <tbody>

                              {userPendingBookings && userPendingBookings?.map((item: any, index: number) => {

                                return (
                                  <tr key={index}>
                                    <td>
                                      <div className="table-avatar">
                                        <Link
                                          to={routes.userBookings}
                                          className="avatar avatar-lg flex-shrink-0"
                                        >
                                          <ImageWithBasePath
                                            className="avatar-img"
                                            src={item?.vehicle?.primary_image}
                                            alt="Booking"
                                          />
                                        </Link>
                                        <div className="table-head-name flex-grow-1">


                                          <div className="table-avatar">
                                            <div className="table-head-name flex-grow-1 mb-1">
                                              <p className="mb-0">    {item?.vehicle?.year_make_model} </p>
                                            </div>
                                          </div>

                                          <p className="mb-0">Booking ID : #{item.booking_id}</p>

                                          <p className="mb-0 text-wrap" > {SetDate(item?.booking_start_date, item?.booking_start_time)} - {SetDate(item?.booking_return_date, item?.booking_return_time)}
                                          </p>

                                        </div>
                                      </div>
                                    </td>

                                    <td className="w-100 text-wrap">
                                      <p className="mb-0"> Following items to be completed. In order to start reservation</p>
                                    </td>

                                    <td className=" w-100">
                                      <StatusStep bookings={item} />

                                    </td>
                                   
                                  </tr>
                                );
                              })}


                            </tbody>
                          </table>




                        </div>

                      </div>
                    </div>
                  </div>

                </>
                } */}

                {activeStatus === null && pendingBookings?.data?.length > 0 && pendingBookings?.meta?.total_items > 0 && <>
                  <div className="col-lg-12 d-flex">
                    <div className="card book-card flex-fill mb-0">
                      <div className="card-header border-bottom-0 mt-0 pt-0 px-0">
                        <div className="row align-items-center">
                          <div className="col-8  col-md-5">
                            <h4 className="align-items-center mb-0"> {"Pending Booking"}

                            </h4>
                          </div>
                        </div>
                      </div>
                      <div className="card-body px-0">
                        <div className="table-responsive dashboard-table">
                          <table className="table datatable">
                            <thead className="d-none d-md-block">
                              <tr>
                                <th className="w-50 w-md-10">Booking ID</th>
                                <th>Pickup/Dropoff Location</th>
                                <th>Trip Start Date</th>
                                <th>Trip End Date</th>
                                <th>Payment Upfront</th>
                                <th>Future Payment</th>
                                <th>Status</th>
                                <th>View Booking</th>
                                <th>Upload License</th>
                                <th>Sign Agreement</th>
                                <th>Preliminary Contract</th>
                                <th>Make Payment</th>
                                <th>Cancel Booking</th>
                              </tr>
                            </thead>
                            <tbody>
                              {userPendingBookings && pendingBookings?.meta?.total_items > 0 ? (
                                userPendingBookings?.map((res, index) => (
                                  <tr key={index}>
                                    <td className="w-50" >{BookingId(res)}</td>
                                    <td className="w-50">{pickupLocation(res)}</td>
                                    <td>{TripStartDate(res)}</td>
                                    <td>{TripEndDate(res)}</td>
                                    <td className="w-100 w-md-50">{PaymentUpfront(res)}</td>
                                    <td className="w-100 w-md-50">{FuturePayment(res)}</td>
                                    <td>{Status(res)}</td>



                                    <td className="align-items-end"><PendingAction data={res} /></td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan={9} className="text-center">
                                    No pending booking found.
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>

                          {pendingBookings?.meta?.total_pagess > 1 && <>
                            <div className="d-flex justify-content-center justify-content-md-end p-2 my-2">
                              <Pagination
                                currentPage={first || 1}
                                totalPages={pendingBookings?.meta?.total_pagess || 1}
                                onPageChange={onPage}
                              />
                            </div>
                            <div className="table-footer">
                              <div className="row">
                                <div className="col-md-6">
                                  <div id="tablelength" />
                                </div>
                                <div className="col-md-6 text-md-end">
                                  <div id="tablepage" />
                                </div>
                              </div>
                            </div></>
                          }
                        </div>
                      </div>
                    </div>
                  </div>

                </>
                }

                {activeStatus === null && cartBookings && cartBookings?.length > 0 && <>
                  <div className="col-lg-12">
                    <div className="card book-card flex-fill mb-0">
                      <div className="card-header border-bottom-0 mt-0 pt-0 px-0">
                        <div className="row align-items-center">
                          <div className="col-8  col-md-5">
                            <h4 className="align-items-center mb-0">
                              {bookingStatusList && activeStatus && bookingStatusList.length > 0
                                ? bookingStatusList
                                  .filter((item: any) => item.id === activeStatus)
                                  .map(({ name }: any) =>
                                    name
                                      ?.toLowerCase()
                                      .replace(/_/g, " ") // Replace underscores with spaces
                                      .replace(/^\w/, (c: string) => c.toUpperCase())
                                  )
                                : "Booking Cart"}

                              {/* <span>{cartBookings?.length}</span> */}
                            </h4>
                          </div>
                        </div>
                      </div>
                      <div className="card-body px-0">
                        <div className="table-responsive dashboard-table">
                          <DataTable
                            className="table datatable"
                            value={cartBookings || []}
                            stripedRows

                            // paginator
                            // rowsPerPageOptions={[10, 25, 50]}
                            // rows={rows}
                            // totalRecords={bookings?.meta?.total ?? 0}
                            // first={first}
                            // lazy
                            // onPage={onPage}
                            selectionMode="single"
                          >
                            <Column field="vehicle" header="Vehicle" body={vehicleDetails} className="w-50 w-md-10"></Column>
                            <Column field="Expires" header="Expires" body={Expires}> </Column>
                            <Column field="tripDate" header="Trip Date" body={CartStartTripDate}> </Column>
                            <Column field="tripDate" header="Trip Date" body={CartEndTripDate}> </Column>
                            <Column field="action" header="Action" className="border-bottom-0" body={CartAction}   ></Column>
                            <Column field=" " header=" " className="border-bottom-0" body={<></>}  ></Column>
                          </DataTable>
                        </div>

                      </div>
                    </div>
                  </div>

                </>
                }


                {bookings?.meta?.total_items > 0 ?
                  <div className="col-lg-12 d-flex">
                    <div className="card book-card flex-fill mb-0">
                      <div className="card-header border-bottom-0 mb-1 mt-0 pt-0 px-0">
                        <div className="row align-items-center">
                          <div className="col-8  col-md-5">

                            <h4 className="align-items-center mb-0">
                              {bookingStatusList && activeStatus && bookingStatusList.length > 0
                                ? bookingStatusList
                                  .filter((item: any) => item.id === activeStatus)
                                  .map(({ name }: any) =>
                                    name
                                      ?.toLowerCase()
                                      .replace(/_/g, " ") // Replace underscores with spaces
                                      .replace(/^\w/, (c: string) => c.toUpperCase())
                                  )
                                : "Bookings History"}

                              <span>{bookings?.meta?.total_items ?? 0}</span>
                            </h4>

                          </div>

                          <div className="col-12 col-md-7 text-md-end d-none d-md-block">
                            <div className="row table-search">
                              <div id="tablefilter" className="col-12 col-md-4 me-md-0 pe-md-0">
                                <label className="d-flex">
                                  <input
                                    type="text"
                                    value={searchInput}
                                    onChange={(e) => setSearchInput(e.target.value)}

                                    placeholder="Search"
                                    className="form-control inputsearch"
                                  />
                                </label>
                              </div>
                              <div className="col-12 col-md-3 " >


                                <Calendar
                                  className="bg-custom py-0"
                                  value={dates.length ? dates : []} // Ensure it's always an array
                                  onChange={(e: any) => setDates(e.value || [])} // Fallback to empty array
                                  placeholder="Choose Date Range"
                                  selectionMode="range"

                                />
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="card-body px-0">
                        <div className="table-responsive dashboard-table">
                          <table className="table datatable">
                            <thead className="d-none d-md-block">
                              <tr>
                                <th className="w-50 w-md-10">Booking ID</th>
                                <th>Pickup/Dropoff Location</th>
                                <th>Trip Start Date</th>
                                <th>Trip End Date</th>
                                <th>Payment Upfront</th>
                                <th>Future Payment</th>
                                <th>Status</th>
                                <th>View Booking</th>
                                <th>Upload License</th>
                                <th>Sign Agreement</th>
                                <th>Preliminary Contract</th>
                                <th>Make Payment</th>
                                <th>Cancel Booking</th>
                              </tr>
                            </thead>
                            <tbody>
                              {userBookings && bookings?.meta?.total_items > 0 ? (
                                userBookings?.map((res, index) => (
                                  <tr key={index}>
                                    <td className="w-50" >{BookingId(res)}</td>
                                    <td className="w-50">{pickupLocation(res)}</td>
                                    <td>{TripStartDate(res)}</td>
                                    <td>{TripEndDate(res)}</td>
                                    <td className="w-100 w-md-50">{PaymentUpfront(res)}</td>
                                    {/* <td className="w-100 w-md-50">{FuturePayment(res)}</td> */}
                                    <td>{Status(res)}</td>

                                    {/* View Booking */}
                                    {/* <td>
                                      <a
                                        href="#"
                                        onClick={() => viewBooking(res?.id)}
                                        data-bs-toggle="modal"
                                        data-bs-target="#view_booking"
                                      >
                                        <i className="fas fa-calendar-alt me-1" /> View Booking
                                      </a>
                                    </td> */}

                                    {/* Upload License */}
                                    {(res?.license_status === "pending" || res?.license_status === "rejected") && <td>

                                      <a
                                        href="#"
                                        data-bs-toggle="modal"
                                        data-bs-target="#upload_license"
                                        onClick={() => setBooking(res)}
                                      >
                                        <i className="fas fa-id-card me-1" /> Upload License
                                      </a>

                                    </td>}

                                    {/* Sign Agreement */}
                                    {res?.agreement_status === "pending" && <td className="align-items-center">

                                      <a
                                        href="#"
                                        data-bs-toggle="modal"
                                        data-bs-target="#terms"
                                        onClick={() => {
                                          viewBooking(res?.id);
                                          clearSignature();
                                        }}
                                      >
                                        <i className="fas fa-file-signature me-1" /> Sign Agreement
                                      </a>

                                    </td>}

                                    {/* View Attachment */}
                                    {res?.bookingattachments?.filter((item: any) => item.label === "agreement")?.length > 0 &&
                                      <td className="  text-left  ">

                                        <a
                                          href="#"
                                          // className="text-wrap"
                                          data-bs-toggle="modal"
                                          data-bs-target="#view_attachment"
                                          onClick={() => {
                                            setBooking(res);
                                            dispatch(resetPasswordAuthenticate());
                                          }}
                                        >
                                          <i className="fa fa-paperclip me-1" /> Preliminary Contract
                                        </a>

                                      </td>}

                                    {/* Make Payment */}
                                    {res?.payment_status === "pending" && <td>

                                      <a
                                        href="#"
                                        data-bs-toggle="modal"
                                        data-bs-target="#make_payment"
                                        onClick={(event) => handlePaymentClick(event, res)}
                                      >
                                        <i className="feather icon-credit-card me-1" /> Make Payment
                                      </a>

                                    </td>}

                                    {/* Cancel Booking */}
                                    {res?.status_name === "pending" && <td>

                                      <a
                                        href="#"
                                        data-bs-toggle="modal"
                                        data-bs-target="#cancel_booking"
                                        onClick={() => setBooking(res)}
                                      >
                                        <i className="fas fa-calendar-times me-1" /> Cancel Booking
                                      </a>

                                    </td>}
                                  </tr>
                                ))
                              ) : (
                                <></>
                              )}
                            </tbody>
                          </table>

                          {bookings?.meta?.total_pages > 1 && <>  <div className="d-flex justify-content-center justify-content-md-end p-2 my-2">
                            <Pagination
                              currentPage={first || 1}
                              totalPages={bookings?.meta?.total_items || 1}
                              onPageChange={onPage}
                            />
                          </div>


                            <div className="table-footer">
                              <div className="row">
                                <div className="col-md-6">
                                  <div id="tablelength" />
                                </div>
                                <div className="col-md-6 text-md-end">
                                  <div id="tablepage" />
                                </div>
                              </div>
                            </div> </>}

                        </div>
                      </div>

                    </div>

                  </div> :


                  bookings?.meta?.total_items === 0 && activeBookings?.meta?.total_items === 0 && pendingBookings?.meta?.total_items === 0 ?
                    <div className="col-lg-12 d-flex">
                      <div className="card book-card flex-fill mb-0">
                        <div className="card-header border-bottom-0 mb-1 mt-0 pt-0 px-0">
                          <p>No reservation found</p>
                        </div>
                      </div>
                    </div> : " "
                }

              </>}


          </div>

        </div>

      </div>


      {/* /Upcoming Booking */}

      <ViewBooking BookedOn={BookedOn} SetDate={SetDate} />
      <CancelBooking booking={booking} />
      <UploadLicense booking={booking} />
      <BookingAttachment booking={booking} />
      {/* <UploadSelfieWithCar booking={booking} />
      <UploadAddressProof booking={booking} /> */}
      <Checkout booking={booking} />

      <UploadSelfieWithCar booking={booking} />

      <UploadAddressProof booking={booking} />



      {<div className="modal new-modal multi-step fade"
        id="make_payment"
        data-keyboard="false"
        data-backdrop="static"
        tabIndex={-1}
      >
        <div className="modal-dialog modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header mb-0 pb-0">
              <div className="mb-1">

                <h6 className="text-nowrap fw-bold">Payment</h6>

              </div>
              <button
                type="button"
                className="close-btn"
                data-bs-dismiss="modal"
              // onClick={() => {
              //   closePaymentModal();
              // }}
              >
                <span>×</span>
              </button>
            </div>
            <div className="modal-body">


              {bookingDetails?.id ? (
                <BookingPayment
                  // bookingId={selectedBookingId} initialPayment={initialPayment}
                  bookings={bookingDetails}
                  enquiry={"hide"}
                />
              ) : (
                <div className="d-flex justify-content-center align-items-center">
                  <Lottie
                    animationData={Loader}
                    loop={true}
                    style={{ width: 300, height: 300 }}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      }

      <Terms clearSignature={clearSignature} handleAccept={handleAccept} showScrollTop={showScrollTop}
        handleScroll={handleScroll} scrollToTop={scrollToTop} BookingAgreement={BookingAgreement}
        isAccepted={isAccepted} termsRef={termsRef} signRef={signRef} loading={bookingDetailLoading}
      />


      <div className="offcanvas offcanvas-end" tabIndex={33} id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
        <div className="offcanvas-header">

          <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close" onClick={() => {
            document.body.style.overflow = "";
            document.body.style.paddingRight = "";
          }}></button>
        </div>
        <div className="offcanvas-body">
          <form
            // onSubmit={handleSubmit}
            action="#"
            autoComplete="off"
            className=""
          >
            <div className="row  ">
              <div id="tablefilter" className="col-12 col-md-5 me-md-0 pe-md-0">
                <label className="d-flex">
                  <input
                    type="text"
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}

                    placeholder="Search"
                    className="form-control inputsearch fs-13"
                  />
                </label>
              </div>
              <div className="col-12 col-md-6 " >


                <Calendar
                  className="  bg-custom py-2 fs-13"
                  value={dates.length ? dates : []} // Ensure it's always an array
                  onChange={(e: any) => setDates(e.value || [])} // Fallback to empty array
                  placeholder="Choose Date Range"
                  selectionMode="range"
                  style={{
                    fontSize: 10
                  }}
                />

              </div>


              <div className="col-12 col-md-6 " >
                <label className="my-1 d-flex">
                  <select
                    className="form-select fs-13"
                    aria-label="Default select example"
                    onChange={(e) => setActiveStatus(parseInt(e.target.value))}
                  >
                    <option value="" className="fs-12">Select Status</option>
                    {bookingStatusList?.map(({ id, name }: any) => (
                      <option key={id} value={id} className="fs-12">
                        {name
                          ?.toLowerCase()
                          .replace(/_/g, " ") // Replace underscores with spaces
                          .replace(/^\w/, (c: string) => c.toUpperCase())} {/* Capitalize first letter */}
                      </option>
                    ))}
                  </select>

                </label>


              </div>

              <div className="col-12 mt-1 " >
                <button
                  type="button"
                  className="fs-13 d-inline-flex align-items-center justify-content-center btn btn-primary filter-btn"
                  data-bs-dismiss="offcanvas" aria-label="Close" onClick={() => {
                    document.body.style.overflow = "";
                    document.body.style.paddingRight = "";
                  }}
                >
                  <span style={{ marginTop: 1 }}>
                    <i className="feather icon-filter fs-12 me-2" />
                  </span>
                  Apply Filter
                </button>
              </div>

            </div>

          </form>

        </div>
      </div>

      {/* <ToastContainer autoClose={3000} limit={1} /> */}


      <EnquiryForm carDetail={carDetail} handleSubmit={contactHandleSubmit} contactUsLoading={contactUsLoading} onSubmit={contactOnSubmit}
        register={contactRegister} errors={contactErrors} timeOptions={timeOptions} systemSettings={systemSettings}
        setShowCalendar={setShowCalendar} showCalendar={showCalendar}
        setStartDate={setAvailabilityStartDate} setEndDate={setAvailabilityEndDate} setFromTime={setAvailabilityFromTime} setUntilTime={setAvailabilityUntilTime}
        startDate={availabilityStartDate} endDate={availabilityEndDate} fromTime={availabilityFromTime} untilTime={availabilityUntilTime}
      />

      <ContactConfirm closeConfirmModal={closeConfirmModal} />


    </>
  );
};

export default UserBookings;